import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b1a4b70c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b1a4b70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a4b70c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1a4b70c')) {
      api.createRecord('b1a4b70c', component.options)
    } else {
      api.reload('b1a4b70c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b1a4b70c&scoped=true&", function () {
      api.rerender('b1a4b70c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/PersonalData/index.vue"
export default component.exports